import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PatternCard from "./PatternCard";
import { Reveal } from "./Reveal";
import { IDEAS, DIAGNOSTIC_DIMS, HIDDEN_SLUGS } from "@/data/content";

export function DiagnosticTieIn({ dim }) {
  const d = DIAGNOSTIC_DIMS[dim];
  if (!d) return null;
  return (
    <section className="border-b border-line/50" data-testid="diagnostic-tie-in">
      <div className="wrap py-14 lg:py-20">
        <Reveal>
          <div className="flex flex-col gap-8 border border-glow/30 bg-charcoal/30 p-8 lg:flex-row lg:items-center lg:justify-between lg:p-10">
            <div className="max-w-xl">
              <p className="kicker">Diagnostic tie-in</p>
              <p className="mt-4 text-lg leading-relaxed text-slate-200">
                This pattern maps to the <span className="text-glow">{d.label}</span> dimension of
                the Operating Reality Diagnostic.
              </p>
              <p className="mt-3 text-sm leading-relaxed text-slate-400">
                Fifteen questions to find out where your version of this problem actually sits.
              </p>
            </div>
            <Link to="/diagnostic" className="btn-primary shrink-0" data-testid="tie-in-diagnostic-cta">
              Take the Diagnostic <ArrowRight size={14} />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function RelatedPatterns({ slug }) {
  const pool = IDEAS.filter((i) => !HIDDEN_SLUGS.includes(i.slug));
  const current = pool.find((i) => i.slug === slug);
  if (!current) return null;
  let related = pool.filter(
    (i) => i.slug !== slug && i.cats.some((c) => current.cats.includes(c))
  );
  if (related.length < 3) {
    const extras = pool.filter((i) => i.slug !== slug && !related.includes(i));
    related = [...related, ...extras];
  }
  related = related.slice(0, 3);
  return (
    <section className="border-t border-line/50" data-testid="related-patterns">
      <div className="wrap py-16 lg:py-20">
        <Reveal>
          <p className="kicker">Related patterns</p>
          <h2 className="mt-4 text-2xl font-medium tracking-tight text-slate-100">
            The same reality, wearing a different uniform.
          </h2>
        </Reveal>
        <div className="mt-10 grid gap-px border border-line/50 bg-line/50 md:grid-cols-3">
          {related.map((idea) => (
            <div key={idea.slug} className="bg-ink">
              <PatternCard idea={idea} testIdPrefix="related-card" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
